module.exports = __webpack_public_path__ + "advancedSlideLeft.png?eb92a41edb095e2d4ca349d56b12cc51";